export default __webpack_public_path__ + "static/media/Secretary.0a70bf06.JPG";